__turbopack_context__.v({
  "button": "AuthWalletConnect-module-scss-module__-aZyya__button",
  "icon": "AuthWalletConnect-module-scss-module__-aZyya__icon",
  "text": "AuthWalletConnect-module-scss-module__-aZyya__text",
});
